module.exports = __webpack_public_path__ + "static/media/aboutUs.522358b0.svg";